export default function ({ store, redirect }) {
  // Se l'utente è già loggato, rimandalo alla dashboard
  if (store.state.auth.loggedIn) {
    return redirect('/area-riservata/dashboard')
  }

  // Se non c'è una mail in attesa di verifica (limbo state),
  // significa che non ha passato il primo step di login.
  if (!store.state.interactions.pendingEmail) {
    return redirect('/area-riservata/login')
  }
}
